module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/suns_sand_2-ae8c571f189e0609b714772b4d69fabb.png";